import { Realty, services } from '@ambita/ambita-components-core';

const filters = services.filters;

function transformOwningCadastres(cadastreData: Realty.ApiResponse) {
  if (cadastreData.item) {
    const cadastre: Realty.ApiCadastre = cadastreData.item;
    const retObject: any = {};

    retObject.owner = filters.cadastre(cadastre.ident);
    return retObject;
  }
}

export default transformOwningCadastres;
